module.exports = __webpack_public_path__ + "static/media/deities2.1a7b28b6.jpg";